import UserActions from "./UserActions";

const UserRow = ({ user }) => {
  const isActive = user.is_active;
  return (
    <tr>
      <td>
        <div>
          <span className="text-md fw-medium text-primary-light">
            {user.nombre_completo}
          </span>
        </div>
      </td>
      <td>
        <span className="text-sm d-block text-secondary-light">
          {user.escuela_nombre}
        </span>
      </td>
      <td>
        <span className="text-sm d-block text-secondary-light">
          {user.plantel_nombre}
        </span>
      </td>

      <td>
        <span
          className={`px-3 py-1 rounded-pill fw-medium text-sm ${
            isActive
              ? "bg-success-focus text-success-main"
              : "bg-danger-focus text-danger-main"
          }`}
        >
          {isActive ? "Activo" : "Inactivo"}
        </span>
      </td>
      <td>
        <span className="text-center text-neutral-700 text-xl">
          <UserActions userId={user.id} isActive={user.is_active} />
        </span>
      </td>
    </tr>
  );
};

export default UserRow;
